<template>
  <div class="file-component" v-invalid="validation.is_valid">
    <div class="field" :class="getFieldClass(field.layout.layout_type)">
      <div class="is-bottom-paddingless" :class="getLabelClass(field.layout.layout_type)">
        <label class="label"
               v-if="field.label"
               :for="field.id">
          <span style="display:list-item; list-style-position: inside"
                :style="{'list-style-type': listMarker}">{{ field.label }}</span>
        </label>
      </div>
      <div class="control is-bottom-paddingless"
           :class="getControlClass(field.layout.layout_type)">
        <div class="file has-name" :class="{ 'has-name': this.fileName }">
          <label class="file-label">
            <input class="file-input"
                   :class="getInputClass(validation.is_valid)"
                   type="file"
                   @change="formData.inputOnChange(field); setFile($event)"
                   :accept="field.properties.accept_file_type"
                   :id="field.id"
                   :name="field.id"
                   :disabled="field.properties.input_readonly">
            <span class="button file-cta is-primary is-outlined">
              <span class="file-icon">
                <i class="mdi mdi-upload"></i>
              </span>
              <span class="file-label" v-translate>
                Upload
              </span>
          </span>
            <span class="file-name">
              {{ fileName }}
            </span>
          </label>
        </div>
        <p class="help is-danger"
           v-if="!validation.is_valid">
          {{ validation.message }}
        </p>
        <p class="help"
           v-if="field.properties.help_text"
           v-html="field.properties.help_text">
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import FormField from '@/classes/form/FormField'
  import FormData from '@/classes/form/FormData'
  import { MAX_UPLOAD_MB, exceedsUploadLimit } from '@/classes/form/uploadLimit'

  export default {
    name: 'file-component',
    props: {
      field: {
        type: FormField
      },
      listMarker: {
        type: String,
        default: 'none'
      },
      formData: {
        type: FormData
      }
    },
    computed: {
      validation () {
        return this.formData.validations[this.field.id] || { is_valid: true }
      },
      fileName () {
        let file = this.formData.fields[this.field.id].value
        return file && file.length ? file[0].name : this.$gettext('choose a file...')
      }
    },
    methods: {
      ...mapActions([
        'errorMessage'
      ]),
      setFile (event) {
        let files = event.target.files
        if (files.length > 0) {
          if (typeof files[0] === 'object') {
            if (exceedsUploadLimit([files[0]])) {
              let translate = this.$gettext('File %{ name } is larger than %{ limit } MB and cannot be uploaded.')
              this.errorMessage(this.$gettextInterpolate(translate, { name: files[0].name, limit: MAX_UPLOAD_MB }))
            } else if (files[0].size) {
              this.removeValidation()
              this.formData.fields[this.field.id].value = [files[0]]
            } else {
              let translate = this.$gettext('File %{ name } is empty and will not be uploaded.')
              this.errorMessage(this.$gettextInterpolate(translate, { name: files[0].name }))
            }
          }
        }
      },
      removeValidation () {
        this.validation.is_valid = true
      },
      getFieldClass (layoutType) {
        return {
          'columns is-multiline is-mobile': layoutType === 'horizontal'
        }
      },
      getLabelClass (layoutType) {
        return {
          'column is-12-mobile is-3-desktop': layoutType === 'horizontal'
        }
      },
      getControlClass (layoutType) {
        return {
          'column is-12-mobile is-9-desktop': layoutType === 'horizontal'
        }
      },
      getInputClass (isValid) {
        return {
          'is-danger': !isValid
        }
      }
    }
  }
</script>

<style lang="sass" scoped>
  .file-component
    margin-bottom: 1.53rem

  .file-input
    height: 0em
    left: 0
    outline: none
    position: absolute
    top: 0
    width: 0.01em
    display: none
</style>
